export default __webpack_public_path__ + "static/media/feedback.a8d6fd4c.svg";